import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const CoccidialStatusList = Loadable(lazy(() => import("./CoccidialStatusList")));
const CoccidialStatusForm = Loadable(lazy(() => import("./CoccidialStatusForm")));

const coccidialStatusRoutes = [
  {
    path: "/CoccidialStatus/CoccidialStatusList",
    element: <CoccidialStatusList />,
    permission: PERMISSIONS.CoccidialStatuses.Menu,
  },
  {
    path: "/CoccidialStatus/CoccidialStatusForm",
    element: <CoccidialStatusForm />,
  },
  {
    path: "/CoccidialStatus/CoccidialStatusForm/:coccidialStatusId",
    element: <CoccidialStatusForm />,
  },
];

export default coccidialStatusRoutes;
